import {createContext, useCallback, useContext, useMemo, useState} from 'react';
import ProductService from '../services/ProductService';

export const ProductDetailContext = createContext();

export const ProductDetailContextProvider = ({ children }) => {
  const [productDetails, setProductDetails] = useState();

  const loadProductDetails = useCallback(async (productCode) => {
    setProductDetails(await ProductService.getProduct(productCode));
  }, []);


  const context = useMemo(() => ({ productDetails, loadProductDetails }), [productDetails]);

  return (<ProductDetailContext.Provider value={context}>
      {children}
    </ProductDetailContext.Provider>);
};

export const useProductDetailContext = () => useContext(ProductDetailContext);
